export enum EstimateProgressStep {
	Info,
	Contact,
	Schedule
}